import { useTranslation } from '@eti/providers';
import { BAGGAGE_SERVICE } from '../../products';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { jsx as _jsx } from "react/jsx-runtime";
export const texts = {
  description: 'baggageServiceAbstractSmallCard',
  title: 'baggageServiceTitle',
  persuasionContent: 'baggageServicePersuasionContent',
  readMoreContent: 'baggageServiceReadMoreModalContent'
};
const SmallBaggageService = _ref => {
  let {
    form,
    isSelected,
    order,
    sellSpecification,
    layoutType
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    description,
    title,
    persuasionContent,
    readMoreContent
  } = getTranslatedTexts(texts, t);
  return /*#__PURE__*/_jsx(SmallCardLayout, {
    description: description,
    form: form,
    isSelected: isSelected,
    layoutType: layoutType,
    order: order,
    persuasion: persuasionContent,
    productId: BAGGAGE_SERVICE.id,
    productName: BAGGAGE_SERVICE.name,
    productType: "traveler",
    readMoreContent: readMoreContent,
    sellSpecification: sellSpecification,
    title: title
  });
};
export default SmallBaggageService;
//# sourceMappingURL=SmallBaggageService.js.map